export default __webpack_public_path__ + "static/media/MICE-contact-img-dt@2x.c6950d7d.jpg";